import {BasicManagedFile} from './basicManagedFile'
import {REP_MARK, REP} from '../Data/typeDirs'
import { genId } from '../utils'
const PHOTOS_SM = 'photos_sm'

const DROPDIR = 'MetaStoryFiles'
const ARCHDIR = 'Archive'
class ReportMarker extends BasicManagedFile {
  constructor(data){
    data = data || {}
    data.content = data.content || {}
    data._id = data._id || genId()
    data.name = data.name || data._id
    super(data)
    this.ext = 'picrep'
    this.typeDir= ReportMarker.getTypeDir()
    // this.construct(data)
  }

  construct(data){
    super.construct(data)
    this._metaMarker = data._metaMarker
    this._report = data._report
    this.name = data._id
    this.version = this.version?this.version:1
    // this._name = data._id
    return this
  }

  serialize(){
    let superSerialized = super.serialize()
    let {_metaMarker, _report} = this
    return {...superSerialized, _metaMarker, _report}
  }

  tryGetAttr(attr){
    const tree = this.getTree()
    const leaf = tree[attr]
    const nf = `No ${attr}`
    if (!leaf) return nf
    const {content} = leaf
    if (!content || !content.length) return nf
    let val = content[0]._mask || content[0]._name
    if (attr === 'markStart') {
      // console.log('getting date', val)
      const date = new Date(parseInt(val, 10))
      // console.log('val in date', date)
      const coeff = 1000 * 60 * 5 // 15 minutes
      const rounded = date.getTime() / coeff
      // console.log('rounded time', rounded, Math.round(rounded))
      const finDate = new Date(Math.round(rounded) * coeff)
      val = `${finDate.toLocaleDateString()} - ${finDate.toLocaleTimeString()}`
      // console.log('returning date', val, val.toLocaleTimeString())
    }
    return val
    // if(!res) res = 'WHOOPS'

  }

  getTree(){
    return this.content.content.data.tree
  }

  getName(){
    return `${this._id}_sm.jpg`
  }

  static getExt(){
    return 'picrep'
  }

  static getIndices(){
    return `${BasicManagedFile.getIndices()},_metaMarker,_report`
  }

  static getTypeDir(){
    return REP_MARK
  }

  async getDropboxPath(repName, ds){
    if(!repName){
      let rep = await ds[REP].get({_id:this._report})
      repName = rep.dirName
    }
    return `/${DROPDIR}/${REP_MARK}/${repName}/${PHOTOS_SM}/${this._id}_sm.jpg`
  }

  static getDropboxArchivePath( id, repName){

    return `/${ARCHDIR}/${REP_MARK}/${repName}/photos/${id}.jpg`

  }

  static getDropboxPath( id, repName){
    // if(!repName){
    //   let rep = await ds[REP].get({_id:this._report})
    //   repName = rep.dirName
    // }
    return `/${DROPDIR}/${REP_MARK}/${repName}/${PHOTOS_SM}/${id}_sm.jpg`
  }

  getLocalPath(locRoot, repName){
    return `${locRoot}/${REP_MARK}/${repName}/${PHOTOS_SM}/${this._id}_sm.jpg`
  }

  static getLocalPath(locRoot, repName, _id){
    return `${locRoot}/${REP_MARK}/${repName}/${PHOTOS_SM}/${_id}_sm.jpg`
  }

  static getLocalFullPath(locRoot, repName, _id){
    return `${locRoot}/${REP_MARK}/${repName}/photos/${_id}.jpg`
  }

  getRootlessPath(repName){
    return `${REP_MARK}/${repName}/${PHOTOS_SM}/${this._id}_sm.jpg`
  }
  async getParent(ds){
    return await ds[REP].get({_id:this._report})
  }

  // static async delete(fileModels, _id){
  //   let {Main, Versions} = fileModels[REP_MARK]
  //   try{
  //     await Main.findOneAndDelete({_id}).exec()
  //     await Versions.deleteMany({_parentId:_id}).exec()
  //   }catch(e){
  //     console.log('failed deleting report marker', _id, e)
  //   }

  // }

  static async archive(fileModels, _id, repMarkToArchive){
    let {Main, Archive} = fileModels[REP_MARK]

    let repMarkArchiveCreateRes,
      repMarkVersionsDeleteManyRes,
      repMarkDeleteSelfRes

    try{
      // console.log('do i need repMarkToArchive?', repMarkToArchive)
      if(!repMarkToArchive) repMarkToArchive = await Main.findOne({_id}).exec()
      // console.log('got repMarkToArchive', repMarkToArchive)
      repMarkArchiveCreateRes = await Archive.findOneAndUpdate({_id}, repMarkToArchive, {upsert:true}).exec()
      // console.log('got repMarkArchiveCreateRes')
      // repMarkVersionsDeleteManyRes = await Versions.deleteMany({_parentId:_id}).exec()
      // console.log('got repMarkVersionsDeleteManyRes')
      // repMarkDeleteSelfRes = await Main.deleteOne({_id}).exec()
      // console.log('got repMarkDeleteSelfRes')
    }catch(e){
      console.log( 'failed archiving repMark',
        repMarkArchiveCreateRes,
        repMarkVersionsDeleteManyRes,
        repMarkDeleteSelfRes,
        e
      )
    }
    return repMarkArchiveCreateRes
  }

  static async delete(fileModels, _id, repMarkToDelete){
    let {Main, Versions} = fileModels[REP_MARK]

    let repMarkDeleteCreateRes,
      repMarkVersionsDeleteManyRes,
      repMarkDeleteSelfRes

    try{
      // console.log('do i need repMarkToDelete?', repMarkToDelete)
      if(!repMarkToDelete) repMarkToDelete = await Main.findOne({_id}).exec()
      // console.log('got repMarkToDelete', repMarkToDelete)
      // repMarkDeleteCreateRes = await Delete.findOneAndUpdate({_id}, repMarkToDelete, {upsert:true}).exec()
      // console.log('got repMarkDeleteCreateRes')
      repMarkVersionsDeleteManyRes = await Versions.deleteMany({_parentId:_id}).exec()
      // console.log('got repMarkVersionsDeleteManyRes')
      repMarkDeleteSelfRes = await Main.deleteOne({_id}).exec()
      // console.log('got repMarkDeleteSelfRes')
    }catch(e){
      console.log( 'failed delete repMark',
        repMarkDeleteCreateRes,
        repMarkVersionsDeleteManyRes,
        repMarkDeleteSelfRes,
        e
      )
    }
    return repMarkToDelete
  }


  static async unarchive(fileModels, _id, repMarkToUnarchive){
    let {Main, Archive} = fileModels[REP_MARK]

    let repMarkUnarchiveCreateRes,
      // repMarkVersionsDeleteManyRes,
      repMarkDeleteSelfRes

    try{
      // console.log('do i need repMarkToArchive?', repMarkToArchive)
      if(!repMarkToUnarchive) repMarkToUnarchive = await Archive.findOne({_id}).exec()
      // console.log('got repMarkToUnarchive', repMarkToUnarchive)
      repMarkUnarchiveCreateRes = await Main.findOneAndUpdate({_id}, repMarkToUnarchive, {upsert:true}).exec()
      // console.log('got repMarkUnarchiveCreateRes')
      // repMarkVersionsDeleteManyRes = await Versions.deleteMany({_parentId:_id}).exec()
      // console.log('got repMarkVersionsDeleteManyRes')
      // repMarkDeleteSelfRes = await Archive.deleteOne({_id}).exec()
      // console.log('got repMarkDeleteSelfRes')
    }catch(e){
      console.log( 'failed archiving repMark',
        repMarkUnarchiveCreateRes,
        repMarkDeleteSelfRes,
        e
      )
    }
    return repMarkToUnarchive
  }

  static async killLocalDBRecords(localdb, _id){
    let res = await localdb[REP_MARK].kill({_id})
    console.log('killing db record for repMarker', _id, res)
    return res
  }

  static async addToMetaStoryFromDBG(dbg_id, _id, get, downloadPhoto, receiveImage, user){
    let mark = await get(REP_MARK, {_id}, user)
    console.log('got mark', _id, dbg_id)
    let rep = await get(REP, {_id:mark._report}, user)
    mark = new ReportMarker(mark)
    // proj = new Report(proj)

    let res = await downloadPhoto({id:dbg_id}, user)
    // console.log('from downloadPhoto', res)
    // let buff = await res.buffer()
    await receiveImage(mark._id, `${REP_MARK}/${rep.dirName}`, res.buffer, user, false, false)
  }
}

export default ReportMarker
